// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__37lOd","range":"MonthRangeSwitch_range__RTe7q","disabled":"MonthRangeSwitch_disabled__19DeC"};